import { render, staticRenderFns } from "./Landscapes.vue?vue&type=template&id=694a6d86&"
import script from "./Landscapes.vue?vue&type=script&lang=js&"
export * from "./Landscapes.vue?vue&type=script&lang=js&"
import style0 from "./Landscapes.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Landscapes.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/ddv-home/ddv-home/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('694a6d86')) {
      api.createRecord('694a6d86', component.options)
    } else {
      api.reload('694a6d86', component.options)
    }
    module.hot.accept("./Landscapes.vue?vue&type=template&id=694a6d86&", function () {
      api.rerender('694a6d86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ddv-home/Landscapes.vue"
export default component.exports